import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/move_review.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/names_and_graph.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/opengraph-image.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/proserpina_dont_capture.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/review.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/summary_and_metrics.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/tgom_capture_off_central_rosette.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/tgom_risky_move.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/panda.svg");
